// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentFormSection_container__2zlY6","addressSection":"PaymentFormSection_addressSection__3OwSB","balance":"PaymentFormSection_balance__1sUXu"};